import createCache from '@emotion/cache'

export default function createEmotionCache(nonce?: string) {
  return createCache({
    key: 'mui',
    nonce,
    prepend: true,
  })
}
